'use client'

import { useCatalog } from '@/features/veluvit/hooks/use-catalog'
import { useSessionStore } from '@/features/veluvit/stores/session.store'

/** 최근 대화방 목록 — 같은 작품의 여러 방도 각 서버 방 ID로 표시한다. */
export function useRecentRooms() {
  const catalog = useCatalog()
  const rooms = useSessionStore((state) => state.data?.rooms)
  return (rooms || []).filter(
    (room) => !room.archived && !!catalog.chars[room.workId]
  )
}
